import React, { memo } from 'react';
import { Flex } from 'pcln-design-system';
import ChildAgeSelect from '../ChildAgeSelect';
import TravelerLineItem from '../TravelerLineItem';
import Divider from '../Divider';
const ChildrenLineItem = ({
  ages,
  ageSelectEnabled,
  className,
  count,
  max,
  isHotel,
  onAgeChange,
  onChange,
  subLabel
}) => {
  const selects = Array(count).fill(0);
  return React.createElement(Flex, {
    flexDirection: 'column',
    width: 1
  }, React.createElement(TravelerLineItem, {
    className: className,
    label: 'Children',
    subLabel: !ageSelectEnabled && subLabel,
    min: 0,
    max: max,
    count: count,
    onChange: onChange
  }), ageSelectEnabled && selects.map((value, index) => React.createElement(React.Fragment, {
    key: `container-${index}`
  }, React.createElement(ChildAgeSelect, {
    key: index,
    index: index,
    isHotel: isHotel,
    value: ages && ages[index],
    onChange: onAgeChange
  }), index !== selects.length - 1 && React.createElement(Divider, null))));
};
export default memo(ChildrenLineItem);